import { useContext } from 'react';
import { EventDispatcherContext } from './EventDispatcherContext';

export default function useEventDispatcher() {
    return useContext(EventDispatcherContext);
}
